import React, { useState } from "react";
import Sider from "../../components/siderbarcomponents.jsx";

interface Transaction {
  date: string;
  type: string;
  company: string;
  grossAmount: string;
  tax: string;
  netAmount: string;
  paymentMethod: string;
  status: string;
}

const transactionsData: Transaction[] = [
  {
    date: "12-Feb-2025",
    type: "Suscripción",
    company: "Expresso Belmira",
    grossAmount: "$1’565.000",
    tax: "$328.650",
    netAmount: "$1’236.350",
    paymentMethod: "Mastercard",
    status: "Completo",
  },
  {
    date: "12-Feb-2025",
    type: "Suscripción",
    company: "Expresso Belmira",
    grossAmount: "$1’565.000",
    tax: "$328.650",
    netAmount: "$1’236.350",
    paymentMethod: "Mastercard",
    status: "Completo",
  },
  {
    date: "12-Feb-2025",
    type: "Suscripción",
    company: "Expresso Belmira",
    grossAmount: "$1’565.000",
    tax: "$328.650",
    netAmount: "$1’236.350",
    paymentMethod: "Mastercard",
    status: "Completo",
  },
  {
    date: "12-Feb-2025",
    type: "Suscripción",
    company: "Expresso Belmira",
    grossAmount: "$1’565.000",
    tax: "$328.650",
    netAmount: "$1’236.350",
    paymentMethod: "Mastercard",
    status: "Completo",
  },
  {
    date: "12-Feb-2025",
    type: "Suscripción",
    company: "Expresso Belmira",
    grossAmount: "$1’565.000",
    tax: "$328.650",
    netAmount: "$1’236.350",
    paymentMethod: "Mastercard",
    status: "Completo",
  },
  {
    date: "12-Feb-2025",
    type: "Suscripción",
    company: "Expresso Belmira",
    grossAmount: "$1’565.000",
    tax: "$328.650",
    netAmount: "$1’236.350",
    paymentMethod: "Mastercard",
    status: "Completo",
  },
  {
    date: "12-Feb-2025",
    type: "Suscripción",
    company: "Expresso Belmira",
    grossAmount: "$1’565.000",
    tax: "$328.650",
    netAmount: "$1’236.350",
    paymentMethod: "Mastercard",
    status: "Completo",
  },
  {
    date: "12-Feb-2025",
    type: "Suscripción",
    company: "Expresso Belmira",
    grossAmount: "$1’565.000",
    tax: "$328.650",
    netAmount: "$1’236.350",
    paymentMethod: "Mastercard",
    status: "Completo",
  },
  {
    date: "12-Feb-2025",
    type: "Suscripción",
    company: "Expresso Belmira",
    grossAmount: "$1’565.000",
    tax: "$328.650",
    netAmount: "$1’236.350",
    paymentMethod: "Mastercard",
    status: "Completo",
  },
  {
    date: "12-Feb-2025",
    type: "Suscripción",
    company: "Expresso Belmira",
    grossAmount: "$1’565.000",
    tax: "$328.650",
    netAmount: "$1’236.350",
    paymentMethod: "Mastercard",
    status: "Completo",
  },
  {
    date: "12-Feb-2025",
    type: "Suscripción",
    company: "Expresso Belmira",
    grossAmount: "$1’565.000",
    tax: "$328.650",
    netAmount: "$1’236.350",
    paymentMethod: "Mastercard",
    status: "Completo",
  },
  {
    date: "12-Feb-2025",
    type: "Suscripción",
    company: "Expresso Belmira",
    grossAmount: "$1’565.000",
    tax: "$328.650",
    netAmount: "$1’236.350",
    paymentMethod: "Mastercard",
    status: "Completo",
  },
  {
    date: "12-Feb-2025",
    type: "Suscripción",
    company: "Expresso Belmira",
    grossAmount: "$1’565.000",
    tax: "$328.650",
    netAmount: "$3’236.350",
    paymentMethod: "Mastercard",
    status: "Completo",
  },
  {
    date: "12-Feb-2025",
    type: "Suscripción",
    company: "Expresso Belmira",
    grossAmount: "$1’565.000",
    tax: "$328.650",
    netAmount: "$1’236.350",
    paymentMethod: "Mastercard",
    status: "Completo",
  },
  {
    date: "12-Feb-2025",
    type: "Suscripción",
    company: "Expresso Belmira",
    grossAmount: "$65.000",
    tax: "$28.650",
    netAmount: "$1’236.350",
    paymentMethod: "Mastercard",
    status: "Completo",
  },
  // Agrega más datos si es necesario
];

const StatsTable: React.FC = () => {
  const [transactions, setTransactions] = useState(transactionsData);
  const [sortField, setSortField] = useState<keyof Transaction | null>(null);
  const [sortAsc, setSortAsc] = useState(true);

  const handleSort = (key: keyof Transaction) => {
    const isAsc = sortField === key ? !sortAsc : true;
    const sortedData = [...transactions].sort((a, b) => {
      return isAsc
        ? a[key].localeCompare(b[key])
        : b[key].localeCompare(a[key]);
    });
    setSortField(key);
    setSortAsc(isAsc);
    setTransactions(sortedData);
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <Sider />

      <div className="flex-1 p-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-[18px] font-semibold text-textSubtitle mt-10 mb-6">
            Control de Transacciones Pixu
          </h2>

          <div className="grid grid-cols-2 gap-4 text-center">
            <div className="p-4 border rounded-lg w-[300px] bg-white">
              <p className="text-sm text-gray-500">Ingresos Netos Mes</p>
              <p className="text-2xl font-bold">$36’900.000</p>
              <p className="text-green-500">↑ 27%</p>
            </div>
            <div className="p-4 border rounded-lg w-[300px] bg-white">
              <p className="text-sm text-gray-500">Ingresos Netos Año</p>
              <p className="text-2xl font-bold">$255’526.001</p>
              <p className="text-green-500">↑ 27%</p>
            </div>
          </div>
        </div>

       
        <div className="p-4 bg-white shadow-md rounded-lg h-[85%] overflow-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b py-4 cursor-pointer">
                {[
                  "date",
                  "type",
                  "company",
                  "grossAmount",
                  "tax",
                  "netAmount",
                  "paymentMethod",
                  "status",
                ].map((key) => (
                  <th
                    key={key}
                    onClick={() => handleSort(key as keyof Transaction)}
                    className="py-4 pl-6 text-left text-[14px] text-textSubtitle font-semibold"
                  >
                    {key.charAt(0).toUpperCase() + key.slice(1)}{" "}
                    {sortField === key ? (sortAsc ? "↑" : "↓") : ""}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {transactions.map((transaction, index) => (
                <tr key={index} className="border-b hover:bg-gray-50">
                  <td className="py-4 pl-6 text-left text-[14px] text-textTipic font-medium">
                    {transaction.date}
                  </td>
                  <td className="py-4 pl-6 text-left text-[14px] text-textTipic font-medium">
                    {transaction.type}
                  </td>
                  <td className="py-4 pl-6 text-left text-[14px] text-textTipic font-medium">
                    {transaction.company}
                  </td>
                  <td className="py-4 pl-6 text-left text-[14px] text-textTipic font-medium">
                    {transaction.grossAmount}
                  </td>
                  <td className="py-4 pl-6 text-left text-[14px] text-textTipic font-medium">
                    {transaction.tax}
                  </td>
                  <td className="py-4 pl-6 text-left text-[14px] text-textTipic font-medium">
                    {transaction.netAmount}
                  </td>
                  <td className="py-4 pl-6 text-left text-[14px] text-textTipic font-medium">
                    {transaction.paymentMethod}
                  </td>
                  <td className="py-4 pl-6 text-left text-[14px] text-green-500 font-bold">
                    {transaction.status}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default StatsTable;
